"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Defaults = {
    baseUrl: "/iwc-api",
    auth: undefined
};
var RestUserDataService = /** @class */ (function () {
    function RestUserDataService() {
    }
    Object.defineProperty(RestUserDataService.prototype, "baseUrl", {
        get: function () {
            return this._baseUrl || Defaults.baseUrl;
        },
        set: function (value) {
            this._baseUrl = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RestUserDataService.prototype, "auth", {
        get: function () {
            return this._auth || Defaults.auth;
        },
        set: function (value) {
            this._auth = value;
        },
        enumerable: true,
        configurable: true
    });
    RestUserDataService.prototype.listUserData = function () {
        return axios_1.default.get(this.baseUrl + "/self/data/").then(function (ar) {
            var r = ar.data;
            return r && r._embedded && r._embedded.item ? r._embedded.item : [];
        });
    };
    RestUserDataService.prototype.getUserData = function (request) {
        return axios_1.default.get(this.baseUrl + "/self/data/" + encodeURIComponent(request.key), { auth: this.auth }).then(function (ar) {
            return ar.data;
        }).catch(function (err) {
            if (err.response && err.response.status !== 404) {
                return Promise.reject(err);
            }
        });
    };
    RestUserDataService.prototype.setUserData = function (data) {
        return axios_1.default.put(this.baseUrl + "/self/data/" + encodeURIComponent(data.key) + "/", data, { auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestUserDataService.prototype.deleteUserData = function (data) {
        return axios_1.default.delete(this.baseUrl + "/self/data/" + encodeURIComponent(data.key) + "/", { auth: this.auth });
    };
    return RestUserDataService;
}());
exports.RestUserDataService = RestUserDataService;
